import { render, staticRenderFns } from "./PopularDestinationDetail.vue?vue&type=template&id=65b09264"
import script from "./PopularDestinationDetail.vue?vue&type=script&lang=js"
export * from "./PopularDestinationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports